import type { ReactNode } from 'react';

// Íconos de acción (trazo 24×24) y botón de ícono: siempre con aria-label y title.

const base = { width: 17, height: 17, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.9, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true };
export const MailIcon = () => <svg {...base}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>;
export const PauseIcon = () => <svg {...base}><circle cx="12" cy="12" r="9" /><path d="M10 9v6M14 9v6" /></svg>;
export const PlayIcon = () => <svg {...base}><circle cx="12" cy="12" r="9" /><path d="m10 8.5 5 3.5-5 3.5z" /></svg>;
export const TrashIcon = () => <svg {...base}><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" /></svg>;
export const DownloadIcon = () => <svg {...base}><path d="M12 4v11M7 10l5 5 5-5M5 20h14" /></svg>;
export const FileIcon = () => <svg {...base}><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5" /></svg>;

const TONE = {
  default: 'text-[#5B5853] hover:bg-paper hover:text-ink',
  danger: 'text-[#8F1D1D] hover:bg-[#FBEAEA]',
  success: 'text-accent-dark hover:bg-accent-soft',
  accent: 'text-accent hover:bg-accent-soft'
} as const;

export function IconButton({ label, onClick, tone = 'default', disabled, children }: {
  label: string; onClick: () => void; tone?: keyof typeof TONE; disabled?: boolean; children: ReactNode;
}) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} title={label} aria-label={label}
      className={`inline-grid h-8 w-8 place-items-center rounded-md transition disabled:cursor-not-allowed disabled:opacity-40 ${TONE[tone]}`}>
      {children}
    </button>
  );
}
